"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { Button } from "@/components/ui/Button";
import { StatusCard } from "@/components/ui/StatusCard";
import { QuizPageNav } from "@/app/quiz/_components/QuizPageNav";
import { reloadOnceForChunkError } from "@/lib/chunks/chunkErrors";

export default function QuizError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
    posthog.captureException(error);
    // unstable_retry() re-renders against the same stale chunk URL and can never
    // recover a ChunkLoadError — only a fresh navigation re-fetches the
    // build manifest. Deferred + cooldown-guarded; falls through to the card below
    // within the cooldown window (see reloadOnceForChunkError's own doc comment).
    reloadOnceForChunkError(error);
  }, [error]);

  return (
    <>
      <QuizPageNav />
      <main className="flex-1 pt-8 sm:pt-12 pb-14">
        <div className="max-w-[1180px] mx-auto px-6">
          <StatusCard
            tone="error"
            title="Something went wrong"
            body="We hit an unexpected error in the quiz. Please try again or head back to the start."
            actions={
              <>
                <Button onClick={() => unstable_retry()}>Try again</Button>
                <Button variant="secondary" href="/quiz">
                  Back to quiz
                </Button>
              </>
            }
          />
        </div>
      </main>
    </>
  );
}
